import { render } from "./board_detail.vue?vue&type=template&id=609088c7"
import script from "./board_detail.vue?vue&type=script&lang=js"
export * from "./board_detail.vue?vue&type=script&lang=js"

import "./board_detail.vue?vue&type=style&index=0&id=609088c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__